module.exports = __webpack_public_path__ + "img/0ad0a68.png";